jQuery(function ($) {
	if( $('.media-list').length ) {
		$('.media-list-item').fitVids();
	}

	if( $('.text-info').length ) {
		$('.text-info').fitVids();
	}
});
